import { STATUS } from '@/constants'
import axios from 'axios'

export class UserApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      // baseURL: 'https://api.prod.photos-presse.com/user',
      baseURL: 'https://api.photos-presse.com/user',
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public async signIn(username: string, password: string): Promise<JSON> {
    console.log('signIn')
    return this.m_instance.post('/sign-in', {
      username: username,
      password: password,
    })
  }

  public async signInAdmin(username: string, password: string): Promise<JSON> {
    console.log('signInAdmin')
    return this.m_instance.post('/sign-in-admin', {
      username: username,
      password: password,
    })
  }

  public async getUsers(): Promise<JSON> {
    console.log('getUsers')

    return this.m_instance.get('/')
  }

  public async create(
    payload: Record<string, string | boolean | Array<string> | STATUS | null>
  ): Promise<JSON> {
    console.log('create')

    return this.m_instance.put('/', payload)
  }

  public async update(payload: Record<string, any>): Promise<JSON> {
    console.log('update')

    return this.m_instance.post('/', payload)
  }

  public async delete(username: string): Promise<JSON> {
    console.log('delete', username)

    return this.m_instance.delete(`/${username}`)
  }
}
